module.exports = "<div ng-repeat=\"option in $ctrl.options\" class=\"btn-group radio-buttons\" data-toggle=\"buttons\" id=\"modelselect\">\n  <label class=\"btn button\" ng-class=\"{'active': $ctrl.model === option.value }\">\n    <input type=\"radio\" value='{{ option.value}}' id=\"{{ $ctrl.name }}\" name=\"{{ $ctrl.name }}\" ng-model=\"$ctrl.model\">\n    <span ng-if=\"option.letter\" class=\"icon easyblank-icon\">{{ option.letter }}</span>{{ option.name }}\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/radio-control/radio-control.html
// module id = 600
// module chunks = 0